module.exports = __webpack_public_path__ + "static/img/a120.02b168e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a120.jpg
// module id = UY5B
// module chunks = 0